import Vue from 'vue'
import Vuex from 'vuex'
import Content from './modules/content'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: true,
    mobileMenu: false,
    noScollBody: false,
    scrollPosition: 0
  },
  getters: {
    loadingStatus (state) {
      return state.isLoading
    },
    mobileMenuStatus (state) {
      return state.mobileMenu
    },
    noScollBodyStatus (state) {
      return state.noScollBody
    },
    getScrollPosition (state) {
      return state.scrollPosition
    }
  },
  mutations: {
    loadingStatus (state, newStatus) {
      state.isLoading = newStatus
    },
    mobileMenuStatus (state, newStatus) {
      state.mobileMenu = newStatus
    },
    noScollBodyStatus (state, newStatus) {
      state.noScollBody = newStatus
    },
    setScrollPosition (state, s) {
      state.scrollPosition = s
    }
  },
  modules: {
    Content
  }
})
